import Users from "./Users/index.js";
class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/batch-provisioning`;
    }
    users() {
        return new Users(this);
    }
}
export default Index;
